import { components } from "@appretio/api";
import { resolveCssVar } from "@appretio/shared";
import { Chart, semanticThemeTokens } from "@appretio/ui-kit";
import { chartWrapper } from "../Chart.css";
import { useCategoryChartOptions } from "./hooks/useCategoryChartOptions";

type ReviewDataProduct = components["schemas"]["InSeasonReviewDataProduct"];

export type InSeasonReviewResponseItem = ReviewDataProduct & {
  nis3_sum: number;
  time_purchase_sum: number;
  st_avg: number;
};

interface CategoryChartProps {
  /**
   * Full dataset
   */
  inSeasonReviewData: InSeasonReviewResponseItem[];
  /**
   * Loading state
   */
  isLoading: boolean;
  /**
   * Chart title (optional)
   */
  title?: string;
  /**
   * Chart subtitle (optional)
   */
  subtitle?: string;
  /**
   * Callback when a category is clicked
   */
  onCategoryClick?: (category: string) => void;
}

export function CategoryChart({
  inSeasonReviewData,
  isLoading,
  title = "Sales, Purchase & Sellthrough",
  subtitle,
  onCategoryClick
}: CategoryChartProps) {
  const { series, axes, listeners } = useCategoryChartOptions({
    inSeasonReviewData,
    onCategoryClick
  });

  return (
    <div className={chartWrapper}>
      <Chart
        isLoading={isLoading}
        options={{
          title: {
            text: title,
            color: resolveCssVar(semanticThemeTokens.chart.textColor)
          },
          subtitle: subtitle
            ? {
                text: subtitle,
                textAlign: "left",
                color: resolveCssVar(semanticThemeTokens.chart.textColor),
                spacing: 40
              }
            : undefined,
          series,
          axes,
          listeners,
          legend: {
            position: "right-top",
            orientation: "vertical",
            spacing: 20
          },
          zoom: {
            axes: "x",
            enabled: true,
            enableSelecting: true,
            anchorPointX: "pointer",
            anchorPointY: "pointer",
            panKey: "shift"
          }
        }}
      />
    </div>
  );
}
